import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import clipboardCopy from 'clipboard-copy';
import PromoFeature from 'wonderbly-components/lib/PromoFeature';
import { localiseUrlII } from 'src/common/utils/format-localised-url';
import { useCountry } from 'src/client/js/view/hooks';
import RichText from '../Prismic/RichText';

const ProductGridMarketingCard = props => {
  const country = useCountry();
  const href = props.href ? localiseUrlII(country, props.href) : null;
  const title = props.promoCodeTitle
    ? <RichText inline fields={props.promoCodeTitle} />
    : props.title;
  const [ctaText, setCtaText] = useState(props.cta);
  const onHandleClick = useCallback(() => {
    clipboardCopy(props.code)
      .then(() => {
        setCtaText(props.ctaCopied || props.cta);
        setTimeout(() => setCtaText(props.cta), 2000);
      });
  }, []);

  return (
    <PromoFeature
      className="product-grid__marketing-card"
      image={isEmpty(props.backgroundImage) ? null : props.backgroundImage}
      title={title}
      center={props.center}
      cta={ctaText}
      backgroundColor={props.backgroundColor}
      onHandleClick={onHandleClick}
      href={href}
      invert={props.invert}
      ctaColor={props.ctaColor}
    />
  );
};

ProductGridMarketingCard.propTypes = {
  href: PropTypes.string,
  backgroundColor: PropTypes.string,
  title: PropTypes.string.isRequired,
  code: PropTypes.string,
  cta: PropTypes.string,
  ctaCopied: PropTypes.string,
  ctaColor: PropTypes.string,
  backgroundImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  promoCodeTitle: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
    }),
  ),
  center: PropTypes.bool,
  invert: PropTypes.bool,
};

export default ProductGridMarketingCard;
